import PropTypes from 'prop-types';
import React from 'react';
import AppLoader from '../AppLoader';

const AppSuspense = ({ children, loadingProps = { delay: 300 } }) => {
  return (
    <React.Suspense fallback={<AppLoader {...loadingProps} />}>
      {children}
    </React.Suspense>
  );
};

AppSuspense.propTypes = {
  children: PropTypes.node.isRequired,
  loadingProps: PropTypes.object,
};

export default AppSuspense;
